module.exports = __webpack_public_path__ + "static/media/IMG_20171026_165217.847f8cfb.jpg";